export function StaticInclude() {
  'ngInject';

  return {
    restrict: 'AE',
    templateUrl: (elem, attrs) => {
      return attrs.src;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-form-control/src/staticInclude.directive.js